import PropTracker from "../../../prop-trackers/prop-tracker.js";

class LabelTrackerLinker {
    constructor(canvasLabelLinker) {
        this._canvasLabelLinker = canvasLabelLinker;

        this._labelTracker = new PropTracker();
    }

    trackLabels(labels, labelEvents) {
        this._labelTracker.track(labels, labelEvents);
    }

    update() {
        this._labelTracker.update(({ props }) => {
            for (const { key, oldValue, newValue } of props.iterateModified()) {
                if (oldValue) {
                    this._canvasLabelLinker.unlink(oldValue);
                }

                if (newValue) {
                    this._canvasLabelLinker.link(newValue);
                }
            }
        });
    }
}

export default LabelTrackerLinker;
